import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { HubAuthService } from '@core/services/hub-auth/hub-auth.service';
import { UserState } from '@core/store/user/user.state';
import { HubUser } from '@core/interfaces/user';
import { OlAccountAuth, OlAccountUser, OlRole } from '@ol/kit';

@Injectable({ providedIn: 'root' })
export class OlAccountAuthAdapter implements OlAccountAuth {
  private readonly store = inject(Store);
  private readonly authService = inject(HubAuthService);

  getUser(): OlAccountUser {
    const user = this.store.selectSnapshot(UserState.user) as HubUser | null;
    // The host's NGXS user loads asynchronously (GetUserApi) after bootstrap,
    // while @ol/kit's provideOlAccount initializer calls this during bootstrap.
    // Signal "not ready yet" by throwing — AccountStore.loadUser() catches it to
    // null, and AppComponent re-runs loadUser() once UserState.user is populated.
    if (!user) {
      throw new Error('[ol-account] user not loaded yet');
    }
    return {
      id: user.auth0Id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      displayName: user.name ?? `${user.firstName} ${user.lastName}`.trim(),
      tenantId: user.tenantId as string,
      roles: (user.role ?? []).map((r) => r.toUpperCase() as OlRole),
    };
  }

  logout(): void {
    this.authService.logout();
  }
}
